<!--
  Generated template for the RegistrationPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>
  <!-- <ion-navbar class="shadow"> -->
    <ion-toolbar class="shadow">
      <ion-buttons slot="start">
        <ion-back-button defaultHref="/" (click)="navCtrl.back()"></ion-back-button>
      </ion-buttons>
      <ion-title class="ion-text-center">
        <!-- <div style="padding-top:15px;padding-bottom:15px; display: flex; justify-content: center;"> -->
          {{'REG_PAGE_TITLE' | translate }}
        <!-- </div> -->
      </ion-title>
    </ion-toolbar>
  <!-- </ion-navbar> -->
</ion-header>

<ion-content class="bg-white">
  <ion-grid>
    <ion-row>
      <ion-col size="12" class="ion-text-center">
        <ion-item lines="none">
          <ion-label position="stacked" style="margin-bottom:10px;">{{ 'LOGIN_EMAIL' | translate }}</ion-label>
          <ion-input class="input"  [(ngModel)]="model['email']"  type="email"></ion-input>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked" style="margin-bottom:10px;">{{ 'LOGIN_PASSWORD' | translate }}</ion-label>
          <ion-input class="input" [(ngModel)]="model.password" type="password"></ion-input>
        </ion-item>
        <ion-item  class="ion-justify-content-start">
          <ion-checkbox mode="ios" [(ngModel)]="rememberMe"></ion-checkbox>
          <ion-label style="margin-left: 15px; color: dimgray;">{{ 'LOGIN_REMEMBERME' | translate }}</ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer class="bg-white">
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-button expand="block"  shape="round" class="btn" style="font-weight: 700; letter-spacing: 1px;" (click)="reg()">
          {{ 'LOGIN_REGISTRATION' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
